(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8765],{

/***/ 80837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro/horoscope",
      function () {
        return __webpack_require__(39905);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67785:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ast1.3555fc46.jpg","height":242,"width":363,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAdEAACAQUBAQAAAAAAAAAAAAABAgADBAUREgYi/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/xAAYEQEAAwEAAAAAAAAAAAAAAAABACFB8P/aAAwDAQACEQMRAD8Ap5us+QvjTyQp3a9oXV0+GYL0DzvQiIlNKHVByf/Z"});

/***/ }),

/***/ 67559:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/astw.5b4b98b6.png","height":245,"width":364,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAP1BMVEWlZqKgXYfdvNiIP2qhWXmMQ4vw4+zjydu5g59zM5SfZZG3faO4gq3XqcvAkqx+Tqqvd5qeTHPYsMqXR3zBi7lJKsSfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nAXBhQEAMAjAsAJzt/9vXYI2NPRTGOlp7FWQuhp4iG6bXZ8JycSVPD8b2wE00RQCugAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 40624:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon-right-arrow.e724f296.svg","height":25,"width":25});

/***/ }),

/***/ 25889:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/line-gray.2a41f7c7.png","height":8,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAD1BMVEV7d3cA7s5HcEz/GDL/FC+MLzciAAAABXRSTlNhEACmbmR3WOMAAAAJcEhZcwAACxMAAAsTAQCanBgAAAARSURBVHicY2BgYGRhZmJgAAAANQALSowucwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 39905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ horoscope; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/assets/images/banner-astto.jpg
/* harmony default export */ var banner_astto = ({"src":"/_next/static/media/banner-astto.1f472dcf.jpg","height":671,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAEAAgMAAAAAAAAAAAAAAAAAAgMTIUH/xAAVAQEBAAAAAAAAAAAAAAAAAAABBP/EABURAQEAAAAAAAAAAAAAAAAAAABB/9oADAMBAAIRAxEAPwCRV2SxS3wBRA//2Q=="});
// EXTERNAL MODULE: ./src/assets/images/ast1.jpg
var ast1 = __webpack_require__(67785);
// EXTERNAL MODULE: ./src/assets/images/icon-right-arrow.svg
var icon_right_arrow = __webpack_require__(40624);
// EXTERNAL MODULE: ./src/assets/images/astw.png
var astw = __webpack_require__(67559);
// EXTERNAL MODULE: ./src/assets/images/line-gray.png
var line_gray = __webpack_require__(25889);
// EXTERNAL MODULE: ./src/styles/astrodaily.module.scss
var astrodaily_module = __webpack_require__(47597);
var astrodaily_module_default = /*#__PURE__*/__webpack_require__.n(astrodaily_module);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/pages/astro/horoscope/index.tsx




// Import Swiper styles















var AstroDaily = function() {
    var ref = (0,react.useState)([]), data = ref[0], setData = ref[1];
    var router = (0,next_router.useRouter)();
    var loadZodiac = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.astro.zodiacList */.Z.astro.zodiacList());
                    case 3:
                        data = _ctx.sent.data;
                        setData(data);
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function loadZodiac() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        loadZodiac();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (astrodaily_module_default()).astro_banner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: banner_astto,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (astrodaily_module_default()).astro_banner_text,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container h_100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (astrodaily_module_default()).astro_banner_main,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (astrodaily_module_default()).astro_banner_main_text,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "Daily Horoscope"
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (astrodaily_module_default()).horoscope_bg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (astrodaily_module_default()).horoscope_astro,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (astrodaily_module_default()).horoscope_astro_head,
                                children: [
                                    "CHOOSE YOUR ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "HOROSCOPE"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (astrodaily_module_default()).wline,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: line_gray/* default */.Z,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center mt-4 mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (astrodaily_module_default()).sub_head,
                                            children: "Senco Gold & Diamonds is the name you can trust for accurate online daily horoscope predictions. We aim at encouraging people to stay optimistic. The daily predictions also include your lucky number and lucky colour for the day depending on your zodiac sign."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (astrodaily_module_default()).sub_head,
                                            children: "Our renowned astrologers consider the movement and position of the sun, moon, stars and planets before giving you an idea of what might happen on that day. Boost your confidence with our Daily Horoscope services online."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (astrodaily_module_default()).icon_container,
                                children: !!data.length && data.map(function(v) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (astrodaily_module_default()).col,
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                onClick: function() {
                                                    router.push("/astro/horoscope/".concat(v.name));
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (astrodaily_module_default()).border_full,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (astrodaily_module_default()).icon_img,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: v.thumbnail_image,
                                                                alt: "",
                                                                height: "200px",
                                                                width: "200px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                v.name,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " ",
                                                                moment_default()(v === null || v === void 0 ? void 0 : v.start_date).format("MMMM DD"),
                                                                " -",
                                                                moment_default()(v === null || v === void 0 ? void 0 : v.end_date).format("MMMM DD")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (astrodaily_module_default()).choose_horoscope,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (astrodaily_module_default()).heading,
                            children: [
                                "Get Your Personalized ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Horoscope"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (astrodaily_module_default()).gline,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: line_gray/* default */.Z,
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (astrodaily_module_default()).astro_bg_main,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row justify-content-center mt-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (astrodaily_module_default()).custom_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: ast1/* default */.Z,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (astrodaily_module_default()).heading,
                                                    children: "Astro Consultation"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Our astro consultation services are customized to help you gain a deeper understanding of your personal life, health and career."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/astro/astrologers",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (astrodaily_module_default()).more,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Book Now"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: icon_right_arrow/* default */.Z,
                                                                alt: ""
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (astrodaily_module_default()).custom_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: astw/* default */.Z,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (astrodaily_module_default()).heading,
                                                    children: "Kundli "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Your Janam Kundli or Life Kushti can be the success tool of your life. We also specialize in Kundli Matching services."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/astro/kundali",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (astrodaily_module_default()).more,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Book Now"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: icon_right_arrow/* default */.Z,
                                                                alt: ""
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var horoscope = (AstroDaily);


/***/ }),

/***/ 47597:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"astro_banner":"astrodaily_astro_banner__hMwIr","astro_banner_text":"astrodaily_astro_banner_text__xYZI5","astro_banner_main":"astrodaily_astro_banner_main__n3S_A","astro_banner_main_text":"astrodaily_astro_banner_main_text__9hOek","about_astro":"astrodaily_about_astro__0uJxC","about_astro_main":"astrodaily_about_astro_main__XHPOn","about_astro_main_img":"astrodaily_about_astro_main_img__q1ycf","about_astro_main_heading":"astrodaily_about_astro_main_heading__dYdW_","about_astro_main_call":"astrodaily_about_astro_main_call__OezP_","call_number":"astrodaily_call_number__7uM1p","more":"astrodaily_more__9vUQ1","horoscope_bg":"astrodaily_horoscope_bg__MCc6G","horoscope_astro_head":"astrodaily_horoscope_astro_head__Og62f","horoscope_bg_row":"astrodaily_horoscope_bg_row___kD_c","horoscope_bg_row_img":"astrodaily_horoscope_bg_row_img__p3Xxt","horoscope_bg_row_img_heading":"astrodaily_horoscope_bg_row_img_heading__LVa5t","horoscope_bg_row_button":"astrodaily_horoscope_bg_row_button__qPAO3","horoscope_bg_row_form":"astrodaily_horoscope_bg_row_form__HGgNd","horoscope_bg_row_form_head":"astrodaily_horoscope_bg_row_form_head__102qe","horoscope_bg_row_form_body":"astrodaily_horoscope_bg_row_form_body__D0eyW","form_control":"astrodaily_form_control___Feen","red_button":"astrodaily_red_button___gkOM","bg_ast":"astrodaily_bg_ast__3kQYB","heading":"astrodaily_heading__qkOxn","choose_horoscope":"astrodaily_choose_horoscope__Pxock","sub_head":"astrodaily_sub_head__qCsEk","horoscope_card":"astrodaily_horoscope_card__wzxS8","horoscope_card_head":"astrodaily_horoscope_card_head__1ysf5","text_card":"astrodaily_text_card__lO9sI","wline":"astrodaily_wline__GcPZq","gline":"astrodaily_gline__AJcDX","new_row_st":"astrodaily_new_row_st__sYVAZ","new_row_st_main":"astrodaily_new_row_st_main__ZkzDU","new_row_st_main_text":"astrodaily_new_row_st_main_text__EuEto","icon_container":"astrodaily_icon_container__szeV_","border_full":"astrodaily_border_full__WraYi","col":"astrodaily_col__XX0ah","icon_img":"astrodaily_icon_img__xWzV_","astro_bg_main":"astrodaily_astro_bg_main__uXqvL","custom_card":"astrodaily_custom_card__n0l3h"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(80837); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);